import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f21346a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contribute" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "代码或文档贡献", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Fork："),
  /*#__PURE__*/_createTextVNode("fork 项目到自己的 GitHub 账户")
], -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Clone："),
  /*#__PURE__*/_createTextVNode("clone 项目到本地开发环境")
], -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "PR："),
  /*#__PURE__*/_createTextVNode("创建新的 pull request 完成贡献")
], -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "文档："),
  /*#__PURE__*/_createTextVNode("编写文档库，整理基础工具使用相关的文档")
], -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "BUG："),
  /*#__PURE__*/_createTextVNode("寻找星汉未来产品的bug并在GitHub提交")
], -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "image i_1" }, null, -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "image i_2" }, null, -1 /* HOISTED */))
const _hoisted_15 = { class: "item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "技术社区布道", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "文章征集："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("原创“云原生”相关文章在相关平台发布")
], -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "技术视频："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("录制使用教程视频在相关平台发布")
], -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "活跃技术氛围："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("在社群、微博等公众平台积极交流技术、活跃社区气氛")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 如何参与社区贡献? ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(" 我们热忱欢迎每位热爱云原生技术的开发者加入社区。"),
          _hoisted_3,
          _createTextVNode(" 在这里，微小的改变和参与都是成为社区开发者的开始，响应“我为人人、人人为我”的号召，一起改变世界！"),
          _hoisted_4,
          _createTextVNode(" 在云原生算力治理开源社区里，您可以参与交流和贡献的方式包括但不限于："),
          _hoisted_5,
          _createTextVNode(" 报告错误、贡献代码、贡献文档等。 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            lg: {offset:3,span:8},
            order: 1
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_typography_title, { level: 5 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 参与"),
                    _hoisted_7
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, {
            xs: 0,
            lg: 13,
            order: 2
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, {
            xs: 0,
            lg: 13,
            order: _ctx.$Store.Public().width>_ctx.$Enum.GridEnum.LG?3:4
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["order"]),
          _createVNode(_component_a_col, {
            xs: 24,
            lg: 8,
            order: _ctx.$Store.Public().width>_ctx.$Enum.GridEnum.LG?4:3
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_typography_title, { level: 5 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 参与"),
                    _hoisted_16
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _hoisted_18,
                    _hoisted_19
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["order"])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}